/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import generateReport from '../../services/Report/generateReport';
import getServicing from '../../services/Report/getServicing';
import getSegment from '../../services/Report/getSegment';
import applyReferential from '../../services/Report/applyReferential';
import calculateTotals from '../../services/Report/calculateTotals';
import createDamage from '../../services/Report/createDamage';
import { DEFAULT_REFERENTIALS_CLIENT, HT_REFERENTIALS } from '../../config';
import { Calculator } from '../../Store/helpers/Calculator';
// import logError from '../../services/Error/postErrorForm';

export class Report {
  constructor({ auth, getLocalReferential, saveReferentials, recordHandler, logError }) {
    this.auth = auth;
    this.getLocalReferential = getLocalReferential;
    this.saveReferentials = saveReferentials;
    this.recordHandler = recordHandler;
    this.logError = logError;
  }

  async processReport(form, sourceCall = null, source = null, params = {}) {
    const { sourceId, id, status } = form.inspection;
    let sourceInfos = source;
    if (sourceInfos === null) {
      sourceInfos = await this.recordHandler.getSource(sourceId, params);
    }
    const sourceName = sourceInfos.source;
    let REFERENTIALS = [];
    if (form.configLevel === 'B') {
      REFERENTIALS = (sourceInfos?.brand?.referentials || []).map((rf) => rf.label);
    } else if (form.configLevel === 'G') {
      REFERENTIALS = sourceInfos?.group.referentialLabels;
    } else {
      REFERENTIALS = sourceInfos?.referentialLabels;
    }

    if (REFERENTIALS.length === 0) {
      console.log(
        `Referentials for source ${sourceName} are ${REFERENTIALS} and referentials length is ${REFERENTIALS.length} of the file ${id}`,
      );
      const bodyError = {
        warning: `Referentials for source ${sourceName} are ${REFERENTIALS} and referentials length is ${REFERENTIALS.length} of the file ${id}`,
      };
      this.logError(JSON.stringify(bodyError));
      REFERENTIALS = DEFAULT_REFERENTIALS_CLIENT;
    }
    if (status !== 6) {
      // getLocalReferential or distant if local doesn't exist
      await this.saveReferentials(REFERENTIALS, this.auth.token(), 'processReport', sourceName);
    }
    // get the infos from the inspection and format to process the report
    const report = await generateReport(form, REFERENTIALS);
    // add damages that needs calculation
    const servicingDamages = await getServicing(report);
    const damages = _.get(report, 'damages', []);
    servicingDamages.map((damage) => damages.push(damage));
    _.set(report, 'damages', damages);
    // get the segments
    const segments = await getSegment(report);
    // get the referential
    const allQuotedDamages = [];
    // apply the referential on the damages
    for (const referentialName of REFERENTIALS) {
      try {
        const quotedDamages = await applyReferential(damages, referentialName, segments, id, sourceName, sourceCall);
        allQuotedDamages.push(...quotedDamages);
      } catch (e) {
        await this.saveReferentials(REFERENTIALS, this.auth.token(), 'applyReferential', sourceName);
        console.log(
          `missing referential with id : ${referentialName} from ${REFERENTIALS} when we try to apply damages for file ${id} from source ${sourceName}`,
        ); // eslint-disable-line no-console
        const bodyError = {
          error: `missing referential with id : ${referentialName} from ${REFERENTIALS} when we try to apply damages for file ${id} from source ${sourceName}`,
        };
        this.logError(JSON.stringify(bodyError));
      }
    }
    // calculate totals
    let totals = calculateTotals(allQuotedDamages, form);
    // add minimum damage
    for (const referentialName of REFERENTIALS) {
      const total = _.get(totals, referentialName, 0);
      try {
        const referential = await this.getLocalReferential(referentialName);
        const minimumFee = _.get(referential, 'config.minimum_fee', 0);
        if (total < minimumFee) {
          const difference = minimumFee - total;
          const minimumFeeDamage = createDamage({
            custom_damage: '',
            is_custom: '',
            damage_picture: '',
            damage_picture2: '',
            cost: difference,
            value: 'minimal_reconditioning_cost',
            element: 'minimal_cost_title',
            timestamp: '',
            zone: 'servicing',
          });
          minimumFeeDamage.referential = referentialName;
          allQuotedDamages.push(minimumFeeDamage);
        }
      } catch (e) {
        console.log(
          `missing referential with id : ${referentialName} from ${REFERENTIALS} when we try to calculateTotals for file ${id} from source ${sourceName}`,
        ); // eslint-disable-line no-console
        const bodyError = {
          error: `missing referential with id : ${referentialName} from ${REFERENTIALS} when we try to calculateTotals for file ${id} from source ${sourceName}`,
        };
        this.logError(JSON.stringify(bodyError));
      }
    }
    totals = calculateTotals(allQuotedDamages, form);
    Report.addDamagesToSection(allQuotedDamages, totals, report.display, REFERENTIALS, form);
    _.set(report, 'damages', allQuotedDamages);
    _.set(report, 'source', sourceName);
    return report;
  }

  static addDamagesToSection(damages, totals, display, REFERENTIALS, form = {}) {
    const calculator = new Calculator({ country: form?.country?.toUpperCase() });
    Object.keys(totals).forEach((zone) => {
      const totalsForZone = totals[zone];
      // case if this is global total
      if (REFERENTIALS.includes(zone)) {
        _.set(display, `totals.${zone}`, totalsForZone);
      } else {
        Object.keys(totals[zone]).forEach((referential) => {
          _.set(display, `${zone}.totals.${referential}`, totalsForZone[referential]);
        });
      }
    });
    damages.forEach((damage) => {
      const zone = _.get(damage, 'zone', 'other');
      const zoneIds = zone.split('_');
      let keyZone = zoneIds.pop();
      if (keyZone === 'damages') keyZone = zoneIds.join('_');
      else keyZone = zone;
      let keySection = keyZone;
      if (Object.prototype.hasOwnProperty.call(display, `${keyZone}_infos`)) keySection = `${keyZone}_infos`;
      const sectionDamages = _.get(display, `${keySection}.damages`, []);
      if (
        (HT_REFERENTIALS.includes(damage?.referential) || damage?.referential.includes('internal')) &&
        damage?.is_custom === true
      )
        _.set(damage, 'cost', Math.round(damage?.cost * calculator.getTaxExcludedVat()));
      sectionDamages.push(damage);
      _.set(display, `${keySection}.damages`, sectionDamages);
    });
  }
}
